import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { fetchKybDetailRequest } from "./store/actions/kybActions";
import { calculateRisk } from "./store/actions/riskTableActions";
import { GetTabs } from "./store/actions/tabsActions";
import { GetCountriesScores } from "./store/actions/scoreActions";
import Loader from "./Loader";
import axios from "axios";
import { DGTL_BACKEND_URL } from "./store/URL";

const FoundationDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setisLoading] = useState(true);
  const { pathname } = location;
  // const { kybDetail, loading, error } = useSelector((state) => state.kyb);
  const { user, company } = useSelector((state) => state.user);
  const [kybDetail, setKybDetail] = useState(null);

  const { countriesScores } = useSelector((state) => state.score);
  const kycMapping = {
    "Risk Level for Identity": "idType1",
    "Risk Level for ID Verification": "idType2",
    "Risk Level for Proof of Address": "proofOfAddressType",
    "Risk Level for Source of Income Proof": "proofOfIncomeType",
  };

  const [selectedOptions, setSelectedOptions] = useState([]);
  let kybId; // Declare kybId with let or const
  let JwtToken; // Declare JwtToken with let or const

  useEffect(() => {
    if (pathname.includes("/foundation-details/")) {
      // window.location.reload()
      const afterDetails = pathname
        .split("/foundation-details/")[1]
        .split("&")[0];
      if (afterDetails) {
        const parts = afterDetails.split("/");
        if (parts.length > 1) {
          kybId = parts[0];
          JwtToken = parts[1];
          localStorage.setItem("token", parts[1]);
          localStorage.setItem("kybID", parts[0]);
        } else {
          console.log("Invalid pathname format.");
        }
      } else {
        console.log("No content after '/details/'.");
      }
    } else {
      setisLoading(false);
      console.log("No '/details/' in pathname.");
    }
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch({ type: "LOAD_USER_REQUEST" }); // Trigger the saga to fetch user data
    }
  }, [dispatch]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const kybId = localStorage.getItem("kybID");
    if (!kybDetail && token) {
      // dispatch(fetchKybDetailRequest(kybId));
      fetchKybDetailRequest();
    }
  }, [dispatch, kybDetail]);

  async function fetchKybDetailRequest() {
    const token = localStorage.getItem("token");
    const kybId = localStorage.getItem("kybID");

    let body = {
      id: kybId, // Use kycId in the request body
      type: "Foundation",
    };

    const response = await axios.post(
      `${DGTL_BACKEND_URL}/admin/kyb/getCorporateClientDetails`,
      body,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const { data } = response.data;
    setKybDetail(data);
    console.log("KYB Data", data);
  }

  const moveToDashboard = () => {
    navigate("/dashboard");
  };

  console.log("kybDetail", kybDetail);

  // my code

  const { tabs } = useSelector((state) => state.tab);

  useEffect(() => {
    if (user && !tabs) {
      if (user && !user?.riskAccess) {
        navigate("/forbidden");
      } else {
        dispatch(GetTabs(company?._id, "corporate"));
      }
    }
  }, [user, user]);

  useEffect(() => {
    if (!countriesScores && company) {
      dispatch(GetCountriesScores(company?._id));
    }
  }, [dispatch, countriesScores, company]);
  console.log("countriesScores", countriesScores);

  const extractedArray = Object.entries(selectedOptions).map(
    ([key, option]) => ({
      name: key,
      rating: option.rating,
    })
  );

  const handleSubmit = async () => {
    let requestedBody = {
      riskLevels: data,
    };
    console.log("requestedBody", requestedBody);
    // e.preventDefault(); // Prevent form submission
    await dispatch(
      calculateRisk(
        requestedBody,
        kybDetail?._id,
        kybDetail?.companyID,
        navigate,
        "foundation",
        user?._id
      )
    );
  };

  const [data, setData] = useState([]);

  //Handle Change

  const handleSelect = (event) => {
    let { name, value, key } = event.target;
    //  console.log(event.target.options[event.target.selectedIndex].getAttribute('key'))
    const selectedOption = event.target.options[event.target.selectedIndex];
    const defaultFild = selectedOption.dataset.default;
    const TitleFild = selectedOption.dataset.title;
    const WeightFild = selectedOption.dataset.weight;

    setData((prevData) => {
      // Ensure prevData is an array
      if (!Array.isArray(prevData)) {
        console.error("Previous state is not an array:", prevData);
        return [];
      }

      // Check if the name already exists in the data array
      const existingIndex = prevData.findIndex((item) => item.name === name);

      if (existingIndex !== -1) {
        // Update the existing entry
        return prevData.map((item, index) =>
          index === existingIndex
            ? {
                ...item,
                title: TitleFild,
                weight: WeightFild,
                DataSource: defaultFild === "true" ? "Default" : "Manual",
                rating: Number(value),
              }
            : item
        );
      } else {
        // Add a new entry to the data array
        return [
          ...prevData,
          {
            name,
            title: TitleFild,
            weight: WeightFild,
            DataSource: defaultFild === "true" ? "Default" : "Manual",
            rating: Number(value),
          },
        ];
      }
    });
  };

  const handleAutoSelect = (event) => {
    let { name, value, key, weight, isDefault } = event.target;

    setData((prevData) => {
      // Ensure prevData is an array
      if (!Array.isArray(prevData)) {
        console.error("Previous state is not an array:", prevData);
        return [];
      }

      // Check if the name already exists in the data array
      const existingIndex = prevData.findIndex((item) => item.name === name);

      if (existingIndex !== -1) {
        // Update the existing entry
        return prevData.map((item, index) =>
          index === existingIndex
            ? {
                ...item,
                title: key,
                weight,
                DataSource: isDefault ? "Default" : "Manual",
                rating: Number(value),
              }
            : item
        );
      } else {
        // Add a new entry to the data array
        return [
          ...prevData,
          {
            name,
            title: key,
            weight,
            DataSource: isDefault ? "Default" : "KYB",
            rating: Number(value),
          },
        ];
      }
    });
  };

  function findCategory(title, countryName) {
    console.log(title, countryName);
    if (countriesScores) {
      for (const item of countriesScores) {
        const field = item?.fields?.find(
          (field) => field?.name === countryName
        );
        if (field) {
          return field.category;
        }
      }
      return null; // Return null if the title or country is not found
    }
  }

  function findFieldByString(searchString) {
    const keywords = {
      "Co-operative": "Cooperative Countries",
      "Non-Cooperative": "Non-Cooperative Country/ML Jurisdictions",
      "Tax Haven": "Tax Haven countries which support terrorist activities",
      "Trade Sanctions": "Countries subject to Economic / Trade Sanctions",
      "Identified by FATF":
        "Countries identified by FATF as not having AML&CFT system",
      Corruption: "Countries on Corruption and Perception Index",
    };

    const matchedTitle = keywords[searchString];

    if (!matchedTitle) {
      return null;
    }

    return matchedTitle;
  }

  function getHighestScoreObject(array) {
    // Return null if array is empty or invalid
    if (!array || array.length === 0) return null;

    // Use reduce to find object with highest score
    return array.reduce((max, current) => {
      return current.score > max.score ? current : max;
    }, array[0]);
  }

  console.log("tabs", tabs);
  useEffect(() => {
    if (kybDetail && countriesScores && tabs && tabs.length > 0) {
      tabs.forEach((tab) => {
        const handleSelection = (option) => {
          handleAutoSelect({
            target: {
              name: tab.title,
              key: option.title,
              weight: tab.weight,
              value: option.score,
              isDefault: option.default,
            },
          });
        };

        const findAndHandleOption = (searchValue) => {
          const searchString = findCategory(tab.title, searchValue);
          console.log("searchString", searchString);
          const optionName = findFieldByString(searchString);

          if (optionName) {
            const matchedOption = tab.scores[0]?.fields.find(
              (option) => option?.title === optionName
            );

            console.log(optionName);
            if (matchedOption) handleSelection(matchedOption);
            console.log(matchedOption);
          } else if (defaultOption) {
            handleSelection(defaultOption);
          }
        };
        const defaultOption = tab.scores[0]?.fields.find(
          (option) => option.default
        );

        switch (tab.title) {
          case "Country of Nationality":
            findAndHandleOption(kybDetail?.founderCountryOfBirth);
            break;
          case "Country of Operation":
            let OperationScoresObj = [];
            kybDetail?.countryOfOperation?.map((item) => {
              const searchString = findCategory(tab.title, item);

              const optionName = findFieldByString(searchString);

              if (optionName) {
                const matchedOption = tab.scores[0]?.fields.find(
                  (option) => option?.title === optionName
                );
                if (matchedOption) {
                  OperationScoresObj.push(matchedOption);
                }
              }
            });
            const mostHighesOperationObj =
              getHighestScoreObject(OperationScoresObj);

            const matchedOption3 = tab.scores[0]?.fields.find(
              (option) => option?.title === mostHighesOperationObj?.title
            );
            if (matchedOption3) {
              handleSelection(matchedOption3);
            } else {
              handleSelection(defaultOption);
            }
            break;

          case "Country of Jurisdiction":
            findAndHandleOption(kybDetail?.countryOfIncorporation);

            break;

          case "Anticipated Incoming activity/mth":
            const matchedOption8 = tab.scores[0]?.fields.find(
              (option) => option?.title === kybDetail?.expectedInflows
            );
            if (matchedOption8) {
              handleSelection(matchedOption8);
            } else if (defaultOption) {
              handleSelection(defaultOption);
            }
            break;

          case "Anticipated Outgoing activity/mth":
            const matchedOption9 = tab.scores[0]?.fields.find(
              (option) => option?.title === kybDetail?.expectedOutflows
            );
            if (matchedOption9) {
              handleSelection(matchedOption9);
            } else if (defaultOption) {
              handleSelection(defaultOption);
            }
            break;
          case "Products Services":
            const productsList = kybDetail?.selectedServices;

            const fields = tab.scores[0]?.fields;

            const matchingFields = fields.filter((field) =>
              productsList.includes(field.title)
            );

            const highestScoreObject = matchingFields.reduce((max, current) =>
              current.score > max.score ? current : max
            );

            if (highestScoreObject) {
              handleSelection(highestScoreObject);
            } else if (defaultOption) {
              handleSelection(defaultOption);
            }
            break;
          case "Country of Residence":
            let ScoresObj = [];
            kybDetail?.taxResidences?.map((item) => {
              const searchString = findCategory(tab.title, item.country);

              const optionName = findFieldByString(searchString);

              if (optionName) {
                const matchedOption = tab.scores[0]?.fields.find(
                  (option) => option?.title === optionName
                );
                if (matchedOption) {
                  ScoresObj.push(matchedOption);
                }
              }
            });
            const mostHighesJurisdicationObj = getHighestScoreObject(ScoresObj);

            const matchedOption1 = tab.scores[0]?.fields.find(
              (option) => option?.title === mostHighesJurisdicationObj?.title
            );
            if (matchedOption1) {
              handleSelection(matchedOption1);
            } else {
              handleSelection(defaultOption);
            }
            break;

          //   case "BUSINESS/INDUSTRY TYPE":
          //     const matchedOption3 = tab.scores[0]?.fields.find(
          //       (option) => option?.title === kybDetail?.businessType
          //     );
          //     if (matchedOption3) {
          //       handleSelection(matchedOption3);
          //     } else if (defaultOption) {
          //       handleSelection(defaultOption);
          //     }
          //     break;
          case "PEP Status":
            let status = kybDetail?.hasPep ? "Yes" : "No";

            const matchedOption6 = tab.scores[0]?.fields.find(
              (option) => option?.title === status
            );
            if (matchedOption6) {
              handleSelection(matchedOption6);
            } else if (defaultOption) {
              handleSelection(defaultOption);
            }
            break;
          default:
            if (defaultOption) {
              handleSelection(defaultOption);
            } else {
              const kycKey = kycMapping[tab.title];
              if (kycKey) {
                const selectedField = kybDetail?.[kycKey]
                  ? tab.scores[0].fields[0]
                  : tab.scores[0].fields[1];
                handleSelection(selectedField);
              }
            }
            break;
        }
      });
    }
  }, [tabs, countriesScores, kybDetail]);

  console.log(data);
  useEffect(() => {
    if (
      kybDetail &&
      data &&
      data.length > 0 &&
      pathname.includes("/foundation-details/")
    ) {
      handleSubmit();
    }
  }, [data, kybDetail]);

  // console.log(tabs)

  function checkKYCValue(title) {
    const kycMapping = {
      "Anticipated Outgoing activity/mth": "expectedOutflows",
      "Anticipated Incoming activity/mth": "expectedInflows",
      "Country of Residence": "taxResidences[0].country",
      "Country of Operation": "countryOfOperation",
      "Country of Jurisdiction": "countryOfIncorporation",
      "Source of Income Legal Structure": "SourceOfIncomeLegalStructure.title",
      "Other Source of Income": "OtherSourcesOfIncome.title",
      "Source of Income from Industry": "SourceOfIncomeLegalStructure.title",
      "Products Services": "services.products[0]",
      "Purpose of Account": "PurposeOfAccount.title",
      "PEP Status": "principles[0].pep",
      "Source of Income from Industry": "SourceOfIncomeFromIndustry.title",
      "Risk Level for Identity": "idType1",
      "Risk Level for ID Verification": "idType2",
      "Risk Level for Proof of Address": "proofOfAddressType",
      "Risk Level for Source of Income Proof": "proofOfIncomeType",
    };

    const kycKey = kycMapping[title];

    if (!kycKey) return "N/A";

    const value = kycKey.split(".").reduce((obj, key) => {
      // If key contains array index like "something[0]"
      const match = key.match(/^(\w+)\[(\d+)\]$/);
      if (match) {
        const [, arrKey, index] = match;
        return obj?.[arrKey]?.[Number(index)];
      }
      return obj?.[key];
    }, kybDetail);

    return value ?? "N/A";
  }

  function isTitleMatching(name, title) {
    // Iterate through each object in the array
    for (let item of data) {
      // Check if the title matches the search string
      if (item.name === name && item.title === title) {
        return true; // Return true if a match is found
      }
    }
    return false; // Return false if no match is found
  }
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="d-flex flex-column bg-light">
          {user?.accountType === "admin" ? (
            <div className="navbar">
              <div></div>
              <button
                className="btn btn-info text-white"
                onClick={moveToDashboard}
              >
                Engine Settings <span>&gt;</span>
              </button>
            </div>
          ) : null}

          <div className="container ">
            <div className="text-center py-5">
              <h3>{kybDetail?.fullName}</h3>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-8">
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    let requestedBody = {
                      riskLevels: data,
                    };
                    // e.preventDefault(); // Prevent form submission
                    await dispatch(
                      calculateRisk(
                        requestedBody,
                        kybDetail?._id,
                        kybDetail?.companyID,
                        navigate,
                        "corporate",
                        user?._id
                      )
                    );
                  }}
                >
                  {/* Country Operation */}
                  {tabs &&
                    tabs.map((d, i) => (
                      <div className="card border-primary mb-4 p-1 rounded-3">
                        <div className="bg-secondary-subtle card-header">
                          <h4 className="mb-2 text-primary">{d.title}</h4>
                        </div>
                        <div className="card-body rounded-bottom-3 bg-light-blue">
                          <div className="row">
                            <label className="col-sm-5 col-form-label">
                              {checkKYCValue(d.title)}
                            </label>
                            <div className="col-sm-7">
                              <Form.Select
                                aria-label="Default select example"
                                name={d.title}
                                // value={countryOperation.id || ""}
                                onChange={handleSelect}
                              >
                                <option>Open this select menu</option>
                                {d?.scores[0]?.fields?.map((fieldOptions) => (
                                  <option
                                    selected={isTitleMatching(
                                      d.title,
                                      fieldOptions.title
                                    )}
                                    key={fieldOptions.title}
                                    value={fieldOptions.score}
                                    data-default={fieldOptions.default}
                                    data-title={fieldOptions.title}
                                    data-weight={d.weight}
                                  >
                                    {fieldOptions.title}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  {/* Submit Button */}
                  <div className="text-center">
                    <Button variant="primary" type="submit">
                      Calculate Risk
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FoundationDetails;
